import React from 'react';

import LoginContainer from 'Container/Login'
import LoginPresentation from 'Presentation/Login'

const LoginScene = () => {
  return (
    <LoginContainer>
      <LoginPresentation />
    </LoginContainer>
  )
}

export default LoginScene